import { NgFor } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTag } from '@fortawesome/free-solid-svg-icons';
import { LanguageService } from '@shared/services/language.service';
import { Auction } from 'src/app/articles-manager/interfaces/auction.interface';
import { Tag } from 'src/app/tags-manager/interfaces/tag.interface';

@Component({
  selector: 'app-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss'],
  standalone: true,
  imports: [
    NgFor,
    FontAwesomeModule
  ]
})
export class TagsComponent implements OnInit {
  faTag = faTag;

  @Input() selectedAuction: Auction;
  @Input() inPreEventStatus: boolean = false;
  selectedAuctionCopyIta: Tag[] = [];
  selectedAuctionCopyEng: Tag[] = [];
  isMemorabid = true;

  constructor(
    protected languageService: LanguageService
  ) { }

  ngOnInit(): void {
    if (this.selectedAuction != null) {
      if (this.selectedAuction.idAuctionType == 1) {
        this.isMemorabid = true;
      } else {
        this.isMemorabid = false;
      }
    }
  }


}
